import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import usePrevious from 'hooks/usePrevious';
import {
  CreationStatus,
  ProjectRegeneration,
} from 'redux/middleware/api/creation-service/types';
import {
  cancelPollForProjectRegeneration,
  pollForProjectRegeneration,
} from 'redux/modules/project/actions';
import { Dispatch } from 'redux/types';

export interface UseProjectRegenerationConfig {
  projectId?: string;
  projectLatestRegeneration?: ProjectRegeneration;
}

export default function useProjectRegeneration({
  projectId,
  projectLatestRegeneration,
}: UseProjectRegenerationConfig) {
  const [isPolling, setIsPolling] = useState(false);
  const previousProjectId = usePrevious(projectId);

  const { id, status } = projectLatestRegeneration ?? {};

  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (
      isPolling &&
      (status === CreationStatus.COMPLETED || status === CreationStatus.FAILED)
    ) {
      setIsPolling(false);

      return undefined;
    }

    if (
      isPolling ||
      !projectLatestRegeneration ||
      !projectId ||
      !id ||
      status === CreationStatus.COMPLETED ||
      status === CreationStatus.FAILED
    ) {
      return undefined;
    }

    dispatch(pollForProjectRegeneration(projectId, id));
    setIsPolling(true);

    return undefined;
  }, [dispatch, id, isPolling, projectId, projectLatestRegeneration, status]);

  useEffect(() => {
    // Runs when the modal closes and the polling for the project regeneration is in progress.
    if (
      previousProjectId !== projectId &&
      projectId === undefined &&
      status !== CreationStatus.COMPLETED &&
      status !== CreationStatus.FAILED
    ) {
      dispatch(cancelPollForProjectRegeneration());
      setIsPolling(false);
    }
  }, [dispatch, id, previousProjectId, projectId, status]);
}
